var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canOp)?_c('Button',{attrs:{"type":_vm.type,"long":_vm.long,"size":_vm.size},on:{"click":_vm.clickBtn}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }